import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { genericFetchData } from "../../../Services/Service";
import { getUserRole } from "../../../Storage/Datastore";

function useMySpace() {
  const [allTasks, setAllTasks] = useState([]);
  const [departments, setDepartments] = useState(null);
  const [platform, setPlatform] = useState(null);
  const [dataTypes, setDataTypes] = useState(null);

  const [filter, setFilter] = useState({
    departments: departments,
    department: null,
    keyword: "",
  });
  const [keyword, setKeyword] = useState("");
  const userRole = getUserRole();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);

  const loadAllTasks = async () => {
    const postData = {
      pageNo: 0,
      pageSize: 20,
      userRole: userRole,
      keyword: filter.keyword,
      department: filter.department,
      dataTypes: dataTypes,
      // role: "OPS_ADMIN",
    };
    const response = await genericFetchData(
      `/myspace/task/all`,
      "POST",
      postData
    );
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setAllTasks(responseData.tasks);
      setCount(responseData.count);
    }
  };

  const fetchAllTasks = async () => {
    const nextPage = page + 1;
    const postData = {
      pageNo: nextPage,
      pageSize: 20,
      userRole: userRole,
      keyword: filter.keyword,
      department: filter.department,
      dataTypes: dataTypes,
      // role: "OPS_ADMIN",
    };

    try {
      const response = await genericFetchData(
        `/myspace/task/all`,
        "POST",
        postData
      );
      const status = response.status;
      const responseData = await response.json();

      if (status === 200) {
        setAllTasks((prevData) => [...prevData, ...responseData.tasks]);
        console.log(allTasks, "from fetch");
      } else {
        console.error("Failed to fetch tasks with status:", status);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const getAllDepartments = async () => {
    const response = await genericFetchData(`/departments/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setDepartments(responseData.departments);
    } else {
      console.log("=======error");
    }
  };

  const getAllPlatform = async () => {
    const response = await genericFetchData(`/data/platform/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setPlatform(responseData.platforms);
      console.log(responseData.platforms, "+++h");
    } else {
      console.log("=======error");
    }
  };

  const handleOpenPopUp = (taleId, dataType, status, taskId, data) => {
    navigate(dataType === "CENTER" ? "/HospitalAddPage" : "/doctorAddPage", {
      state: { id: taleId, status: status, taskId: taskId, data: data },
    });
  };

  useEffect(() => {
    setAllTasks(null);
    loadAllTasks();
  }, [dataTypes, filter, keyword]);

  // useEffect(() => {
  //   getAllDepartments();
  //   getAllPlatform();
  // }, [filter.department, keyword, dataTypes, filter]);

  return {
    allTasks,
    handleOpenPopUp,
    setFilter,
    setKeyword,
    setDataTypes,
    departments,
    platform,
    dataTypes,
    fetchAllTasks,
    setAllTasks,
    count,
  };
}

export default useMySpace;
